import type { Visit } from '../../types';
import { formatDate } from '../../utils/formatDate';
import { MARKER_COLORS } from '../../utils/markerColor';

interface VisitListProps {
  visits: Visit[];
}

const VISIT_LABELS: Record<string, string> = {
  solo: 'Solo',
  family: 'Family',
  group: 'Group',
  markanya: 'Mark & Anya',
};

export function VisitList({ visits }: VisitListProps) {
  if (visits.length === 0) {
    return (
      <p style={{ color: '#9e9e9e', fontSize: 13, padding: '8px 16px' }}>
        No visits recorded yet.
      </p>
    );
  }

  return (
    <div style={{ padding: '0 16px 16px' }}>
      <h3 style={{ fontSize: 14, fontWeight: 600, color: '#616161', margin: '12px 0 8px', textTransform: 'uppercase', letterSpacing: 0.5 }}>
        Visits
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {visits.map((v) => (
          <div
            key={v.UserPlaceId}
            style={{
              background: '#fafafa',
              border: '1px solid #e0e0e0',
              borderRadius: 8,
              padding: 12,
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontWeight: 600, fontSize: 14 }}>{v.DisplayName}</span>
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  color: '#fff',
                  background: MARKER_COLORS[v.VisitType] ?? '#9e9e9e',
                  borderRadius: 12,
                  padding: '2px 8px',
                }}
              >
                {VISIT_LABELS[v.VisitType] ?? v.VisitType}
              </span>
            </div>
            {v.VisitDate && (
              <p style={{ margin: '4px 0 0', fontSize: 12, color: '#757575' }}>
                {formatDate(v.VisitDate)}
              </p>
            )}
            {v.Notes && (
              <p style={{ margin: '6px 0 0', fontSize: 13, color: '#424242' }}>{v.Notes}</p>
            )}
            {v.UserImageBlobURL && (
              <img
                src={v.UserImageBlobURL}
                alt="Visit memory"
                style={{ marginTop: 8, maxWidth: '100%', borderRadius: 6 }}
              />
            )}
            {v.groupMembers.length > 0 && (
              <p style={{ margin: '6px 0 0', fontSize: 12, color: '#757575' }}>
                With: {v.groupMembers.map((m) => m.DisplayName).join(', ')}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
